// import 'slick-carousel';
import 'jquery-selectric';
// import GLightbox from 'glightbox';

const handler = ( $ ) => {
	let selectricLabelIndex = 0;
	let selectricInputIndex = 0;
	const sanitizeLabelId = ( value ) =>
		value.replace( /[^a-zA-Z0-9_-]/g, '-' );
	const ensureSelectricInputId = ( $input, $select ) => {
		if ( $input.attr( 'id' ) ) {
			return;
		}

		const baseSource =
			$select.attr( 'id' ) || $select.attr( 'name' ) || 'selectric-input';

		selectricInputIndex += 1;
		$input.attr(
			'id',
			`selectric-input-${ sanitizeLabelId(
				baseSource
			) }-${ selectricInputIndex }`
		);
	};
	const ensureSelectricLabelId = ( $label, $select ) => {
		let labelId = $label.attr( 'id' );

		if ( labelId ) {
			return labelId;
		}

		const base = sanitizeLabelId(
			$select.attr( 'id' ) || $select.attr( 'name' ) || 'selectric'
		);

		selectricLabelIndex += 1;
		labelId = `selectric-label-${ base }-${ selectricLabelIndex }`;
		$label.attr( 'id', labelId );

		return labelId;
	};

	const applySelectricInputLabel = ( element, instance ) => {
		if ( ! instance || ! instance.elements || ! instance.elements.input ) {
			return;
		}

		const $select = $( element );
		$select.attr( 'aria-hidden', 'true' ).prop( 'tabindex', -1 );

		const $input = instance.elements.input;

		ensureSelectricInputId( $input, $select );

		if ( $input.attr( 'aria-labelledby' ) || $input.attr( 'title' ) ) {
			return;
		}

		const labelledBy = $select.attr( 'aria-labelledby' );

		if ( labelledBy ) {
			$input.attr( 'aria-labelledby', labelledBy );
			return;
		}

		const selectId = $select.attr( 'id' );
		let $label = selectId
			? $( `label[for="${ selectId }"]` ).first()
			: $( [] );

		if ( ! $label.length ) {
			$label = $select.closest( 'label' );
		}

		if ( $label.length ) {
			$input.attr(
				'aria-labelledby',
				ensureSelectricLabelId( $label, $select )
			);
			return;
		}

		const fallbackLabel =
			$select.attr( 'aria-label' ) || $select.attr( 'title' );

		if ( fallbackLabel ) {
			$input.attr( 'title', fallbackLabel );
			$input.attr( 'aria-label', fallbackLabel );
			return;
		}

		const wrapperLabel = $select
			.closest( '.select' )
			.find( '> p' )
			.first()
			.text()
			.trim();

		if ( wrapperLabel ) {
			$input.attr( 'title', wrapperLabel );
			$input.attr( 'aria-label', wrapperLabel );
			return;
		}

		const nameLabel = $select.attr( 'name' ) || $select.attr( 'id' );

		if ( nameLabel ) {
			const normalizedLabel = nameLabel.replace( /[_-]+/g, ' ' ).trim();
			const labelValue = normalizedLabel || 'Select option';

			$input.attr( 'title', labelValue );
			$input.attr( 'aria-label', labelValue );
			return;
		}

		$input.attr( 'title', 'Select option' );
		$input.attr( 'aria-label', 'Select option' );
	};

	// disable autocomplete
	$( 'form, input, textarea' )
		.attr( 'autocomplete', 'off' )
		.attr( 'spellcheck', 'false' )
		.attr( 'autocorrect', 'off' );

	// responsive frames
	$( '#content iframe' )
		.not( '.gform_wrapper + iframe' )
		.each( function () {
			const $iframe = $( this );

			if ( ! $iframe.parent().hasClass( 'embed-container' ) ) {
				$iframe.wrap( '<div class="embed-container"></div>' );
			}
		} );

	// responsive tables
	$( 'table' ).wrap( '<div class="responsive-table"></div>' );

	// paragraphs that wrap inline images need their own spacing class
	$( '.section-text p' ).has( '> img' ).addClass( 'with-inline-image' );

	// paragraphs that wrap inline buttons need their own spacing class
	$( '.section-text p' ).has( '> .btn' ).addClass( 'with-inline-btn' );

	// initialize selectric
	const $selects = $( 'select' ).not( '.no-selectric' );
	$selects.selectric( {
		disableOnMobile: false,
		onInit: applySelectricInputLabel,
		onRefresh: applySelectricInputLabel,
	} );
	$selects.prop( 'tabindex', -1 );

	const $searchResultsForm = $( '.section-search-results__form' );
	if ( $searchResultsForm.length ) {
		const $searchInput = $searchResultsForm
			.find( '.site-header__search-input' )
			.first();
		const $clearButton = $searchResultsForm
			.find( '.section-search-results__clear' )
			.first();

		if ( $searchInput.length && $clearButton.length ) {
			$clearButton.on( 'click', function ( event ) {
				event.preventDefault();
				$searchInput.val( '' );
				$searchInput.trigger( 'input' );
				$searchInput.trigger( 'focus' );
			} );
		}
	}
};

export default ( ( $ ) => $( handler ) )( jQuery );
